declare global {
  interface Window {
    __RUNTIME_CONFIG__?: Record<string, unknown>;
  }
}

export function getPublicAssetUrl(path: string, baseUrl?: string): string {
  const base = baseUrl ?? import.meta.env.BASE_URL ?? "/ui/";

  const normalizedBase = base.endsWith("/") ? base : `${base}/`;
  const normalizedPath = path.startsWith("/") ? path.slice(1) : path;

  return `${normalizedBase}${normalizedPath}`;
}

/**
 * Loads runtime configuration from `config.json` and attaches it to
 * `window.__RUNTIME_CONFIG__`. Safe to call multiple times.
 */
export async function loadRuntimeConfig(baseUrl?: string): Promise<void> {
  try {
    const res = await fetch(getPublicAssetUrl("config.json", baseUrl), {
      cache: "no-store",
    });

    if (res.ok) {
      window.__RUNTIME_CONFIG__ = await res.json();
    } else {
      console.warn(
        "[loadRuntimeConfig] Could not load config.json:",
        res.status
      );
    }
  } catch (err) {
    console.warn("[loadRuntimeConfig] Failed to fetch config.json:", err);
  }
}

/**
 * Returns the loaded runtime config. Optionally throws if missing.
 */
export function getRuntimeConfig<T = unknown>(
  throwIfMissing = false
): T | undefined {
  if (!window.__RUNTIME_CONFIG__ && throwIfMissing) {
    throw new Error("Runtime config not loaded yet.");
  }
  return window.__RUNTIME_CONFIG__ as T | undefined;
}
